<template>
  <div id="owner_businesses_missing_info_list">
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>


<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from '../../../lib/Utils';
export default {
  name: "OwnerMissingInfo",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
          {
          text: "Missing",
          align: "start",
          sortable: false,
          value: "missing",
          filterable: true,
        },
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          filterable: true,
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {

    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_missing_info_report(
        {
          user_id: this._user.id,
        },
        (res) => {
            //console.log("res: ", res);
          this.items = Utils.scan_businesses_missing_info(
              res.businesses,
              res.hollidays
          );

          this.$emit("set-missing-badge-count",this.items.length);

          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading busineeses on owners businessese missing info list",
            errors
          );
        }
      );
    },
    on_view_item(item) {
      this.$router.push("/owner/businesses/list/view/" + item.business_id);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "Missing Info List",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Missing",
          disabled: false,
          href: "/owner/missing/",
        },
        {
          text: "List",
          disabled: true,
          href: "/owner/missing/info",
        },
      ],
    });
    this.load_items();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_businesses_missing_info_list", options);
  },
};
</script>